import { ShippingSpec } from '~/types/resources';
import { GachaDetail } from '~/types/resources/gachaDetail';

export type CalculatePaymentAmountsInput = {
  isPlayTicketPayment: boolean;
  skipDelivery: boolean;
  bundleAmount: number;
  playAmount: number;
  gachaDetail: GachaDetail;
  shippingSpec: ShippingSpec | undefined;
};

/**
 * 純粋なガチャ購入回数分の値段
 */
const productTotalPrice = (input: CalculatePaymentAmountsInput): number => {
  return input.gachaDetail.price * input.playAmount;
};

/**
 * 配送料
 */
const deliveryCharge = (input: CalculatePaymentAmountsInput): number => {
  if (input.shippingSpec === undefined) return 0;
  if (input.shippingSpec.bundle_capacity === 0) {
    // 注文毎に送料が発生する場合はガチャに設定された送料をそのまま返す
    return input.shippingSpec.charge;
  }
  return input.bundleAmount * input.shippingSpec.charge;
};

/**
 * 値引き額
 */
const discountedPrice = (input: CalculatePaymentAmountsInput): number => {
  if (input.isPlayTicketPayment) {
    return productTotalPrice(input) + deliveryCharge(input);
  }
  return 0;
};

/**
 * 実際にユーザが支払う値段
 */
const totalPrice = (input: CalculatePaymentAmountsInput): number => {
  if (input.skipDelivery) return productTotalPrice(input);
  return (
    productTotalPrice(input) + deliveryCharge(input) - discountedPrice(input)
  );
};

export type PaymentAmounts = {
  productTotalPrice: number;
  deliveryCharge: number;
  discountedPrice: number;
  totalPrice: number;
};

export const calculatePaymentAmounts = (
  input: CalculatePaymentAmountsInput
): PaymentAmounts => {
  return {
    productTotalPrice: productTotalPrice(input),
    deliveryCharge: deliveryCharge(input),
    discountedPrice: discountedPrice(input),
    totalPrice: totalPrice(input),
  };
};
